import { useState, useEffect, useCallback } from 'react';
import { getPhoneConsent, hasExistingConsent, updatePhoneConsent } from './phone-consent-api';

type PhoneConsentState = {
  hasConsent: boolean;
  isLoading: boolean;
  saveConsent: (phoneNumber: string, accepted: boolean) => Promise<void>;
  refetch: () => void;
};

export const usePhoneConsent = (): PhoneConsentState => {
  const [hasConsent, setHasConsent] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const fetchConsent = useCallback(async () => {
    setIsLoading(true);
    try {
      const data = await getPhoneConsent();
      setHasConsent(hasExistingConsent(data));
    } catch {
      setHasConsent(false);
    } finally {
      setIsLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchConsent();
  }, [fetchConsent]);

  const saveConsent = useCallback(async (phoneNumber: string, accepted: boolean) => {
    await updatePhoneConsent(phoneNumber, accepted);
    setHasConsent(accepted);
  }, []);

  return { hasConsent, isLoading, saveConsent, refetch: fetchConsent };
};
